export const ModelIds = {
	relationship: {
		moduleModule: "module_module-v2-relationship"
	},
	document: {
		fachverfahren: "fachverfahren-v3-document",
		module: "module-v2-document",
		printTemplate: "print_template-v2-document"
	},
	overview: {
		fachverfahren: "fachverfahren-overview",
		stammdaten: "stammdaten-overview"
	},
	application: { editor: "editor-application", modules: "modules-application" }
} as const;

export const ModelElementIds = {
	fachverfahrenTree: {
		column: {
			hints: "column-80131",
			name: "column-1a1b4",
			dockingPoint: "column-37492"
		},
		button: {
			save: "button-aa195",
			preview: "button-d5b06",
			publish: "button-ce4ae",
			export: "button-84421",
			download: "button-69767",
			validate: "button-be652",
			clients: "button-3c292",
			roles: "button-8b2d4"
		}
	},
	fachverfahrenOverview: {
		name: "column-af8af",
		status: "column-92ac6",
		hints: "column-c665f",
		key: "column-3b1a5",
		version: "column-370b2",
		internalApplication: "column-48f74",
		client: "column-14a8d",
		preview: "column-cb965"
	},
	printTemplateOverview: {
		name: "column-b1388",
		client: "column-dd42d"
	}
} as const;

export const ModelElementNames = {
	fachverfahrenForm: {
		textCell: {
			confirmationText: "confirmation-text"
		},
		button: {
			confirm_update: "confirm_update",
			confirm_publish: "confirm_publish"
		}
	}
} as const;

export const Events = {
	overview: {
		refresh: "refresh"
	},
	fachverfahren: {
		add: "fachverfahren_add",
		open: "fachverfahren_open",
		edit: "fachverfahren_edit",
		editClient: "fachverfahren_edit_client",
		save: "fachverfahren_save",
		delete: "fachverfahren_delete",
		deleteAll: "fachverfahren_delete_all",
		validate: "fachverfahren_validate",
		update: "fachverfahren_update",
		publish: "fachverfahren_publish",
		preview: "fachverfahren_preview",
		import: "fachverfahren_import",
		export: "fachverfahren_export",
		download: "fachverfahren_download",
		managePortalClients: "fachverfahren_manage_portal_clients",
		createRole: "fachverfahren_create_role"
	},
	module: {
		select: "module_select",
		add: "module_add",
		view: "module_view",
		edit: "module_edit",
		update: "module_update",
		replace: "module_replace",
		remove: "module_remove",
		duplicate: "module_duplicate",
		open: "module_open",
		rename: "module_rename"
	},
	moduleConfiguration: {
		modelIdMap: {
			add: "model_add",
			edit: "model_edit",
			share: "model_share",
			remove: "model_remove"
		}
	},
	printTemplate: {
		add: "print_template_add",
		edit: "print_template_edit",
		open: "print_template_open",
		rename: "print_template_rename",
		editClient: "print_template_edit_client",
		delete: "print_template_delete"
	}
} as const;

export const Annotations = {
	customComponents: {
		type: "type"
	}
} as const;

export const ExternalEnumerationSource = {
	externalIds: "externalIds"
} as const;
